import { AppLayout as AppLayoutV2 } from '_v2/layouts/app';
import NotFound from '_v2/pages/404';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import {
  noAuthRoutes,
  protectedRoutes,
  publicRoutes,
  redirectRoutes,
} from 'configs/RoutesConfig';
import AppLayout from 'layouts/AppLayout';
import AuthLayout from 'layouts/AuthLayout';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import AppRoute from './AppRoute';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

const Routes = () => {
  return (
    <RouterRoutes>
      {noAuthRoutes.map((route) => {
        return (
          <Route
            key={route.key}
            path={route.path}
            element={
              <AppRoute
                routeKey={route.key}
                component={route.component}
                {...route.meta}
              />
            }
          />
        );
      })}

      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
        />
        {protectedRoutes.map((route, index) => {
          let Layout = null;

          if (!route.withoutLayout) {
            if (route.key.startsWith('v2-')) {
              Layout = AppLayoutV2;
            } else if (route.key.startsWith('vTrips-')) {
              Layout = null;
            } else {
              Layout = AppLayout;
            }
          }

          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                Layout ? (
                  <Layout>
                    <AppRoute
                      routeKey={route.key}
                      component={route.component}
                      {...route.meta}
                    />
                  </Layout>
                ) : (
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                )
              }
            />
          );
        })}
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AuthLayout>
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                </AuthLayout>
              }
            />
          );
        })}
      </Route>
      {redirectRoutes.map((route) => {
        return <Route path={route.from} element={<Navigate to={route.to} />} />;
      })}
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
};

export default Routes;
